import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { palette } from '@noths/polaris-design-system-theme-brand2026customer';
import { css } from 'styled-components';

const { fonts, spacing } = theme;

export const button = css`
  background-color: ${palette.purple10};
  border: 1px solid ${palette.purple70};
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: ${spacing.xs}px;
  padding: 9px;
  position: relative;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;
  box-sizing: border-box;
  max-width: 100%;
  flex-shrink: 0;

  &:hover:not(:disabled) {
    background-color: ${palette.purple30};
    border-color: ${palette.purpleBase};
  }

  &:active:not(:disabled) {
    background-color: ${palette.purple50};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid ${palette.purpleBase};
    outline-offset: 2px;
  }
`;

export const iconWrapper = css`
  height: 19px;
  position: relative;
  flex-shrink: 0;
  width: 21px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const curatorImage = css`
  display: block;
  width: 21px;
  height: 19px;
  pointer-events: none;
`;

export const textWrapper = css`
  display: flex;
  flex-direction: column;
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  justify-content: center;
  line-height: 0;
  position: relative;
  flex-shrink: 0;
  color: ${palette.purpleBase};
  font-size: 14px;
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  text-align: center;
  white-space: nowrap;

  /* Hide text on mobile */
  ${mediaQuery(
    { max: maxBreakpoints.M },
    css`
      display: none;
    `,
  )};
`;

export const text = css`
  line-height: 24px;
  margin: 0;
  color: ${palette.purpleBase};
`;

export const badge = css`
  position: absolute;
  top: -8px;
  left: 5px;
  right: unset;
  display: flex;
  width: 30px;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0 4px;
  background-color: ${palette.green10};
  border-radius: 4px;

  /* Desktop: stick out */
  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      top: -8px;
      right: 12px;
      left: unset;
    `,
  )};
`;

export const badgeText = css`
  color: ${palette.neutralBrandBlack};
  font-family: 'NOTHS Sans No3';
  font-size: 10px;
  line-height: 15px;
  font-weight: 600;
  margin: 0;
  display: inline;
`;
